import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Badge } from './ui/badge';
import { ChevronDown } from 'lucide-react';

const StatusBadge = ({ status, taskId, onStatusChange }) => {
  const statuses = ['pending', 'in-progress', 'order-placed', 'in-transit', 'completed', 'blocked'];

  const getStyles = () => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'in-progress':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'order-placed':
        return 'bg-purple-100 text-purple-700 border-purple-200';
      case 'in-transit':
        return 'bg-orange-100 text-orange-700 border-orange-200';
      case 'blocked':
        return 'bg-red-100 text-red-700 border-red-200';
      default:
        return 'bg-slate-100 text-slate-700 border-slate-200';
    }
  };

  const formatStatus = (s) => {
    return s.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Badge
          className={`${getStyles()} cursor-pointer flex items-center gap-1 font-semibold hover:opacity-80 transition-opacity`}
          data-testid={`status-badge-${taskId}`}
          onClick={(e) => e.stopPropagation()}
        >
          {formatStatus(status)}
          <ChevronDown className="h-3 w-3" />
        </Badge>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {statuses.map((s) => (
          <DropdownMenuItem
            key={s}
            onClick={(e) => {
              e.stopPropagation();
              onStatusChange(taskId, s);
            }}
            data-testid={`status-option-${s}`}
            className="cursor-pointer"
          >
            {formatStatus(s)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default StatusBadge;
